<template>
	<div class="navbar-container main-menu-content">
		<horizontal-nav-menu-items :items="navMenuItems" />
	</div>
</template>

<script>
import { getUserRoles } from "@/auth/utils"
import HorizontalNavMenuItems from "./components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue"

export default {
	components: {
		HorizontalNavMenuItems
	},
	data() {
		return {
			renderComponent: true,
			navMenuItems: []
		}
	},
	mounted() {
		const { isVerifier } = getUserRoles()
		setTimeout(async () => {
			let mylib = require("@/navigation/horizontal")
			if (isVerifier) {
				mylib = require("@/navigation/horizontal/index2")
			}
			this.navMenuItems = mylib.default
		}, 300)
	}
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>